import { fetchStatuses, injectColorsStatus } from './statuses.utils';
import isEmpty from 'lodash/isEmpty';
import set from 'lodash/set';

const statuses = {
    namespaced: true,
    state: {
        error: {},
        list: [],
        fetching: false,
        promises: {
            loadAll: {
                feedback: null,
                idea: null,
            },
        },
    },
    mutations: {
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
        setList (state, { list }) {
            state.list = list;
        },
        updateList (state, { list }) {
            state.list.push(...list);
        },
        setError (state, { error }) {
            state.error = error;
        },
        clearList (state, { type }) {
            state.list = state.list.filter((status) => status.type !== type);
        },
        setPromise (state, { promise, key }) {
            set(state.promises, key, promise);
        },
    },
    actions: {
        loadAll ({ commit, state, getters }, { reFetch = false, type = 'idea' } = {}) {
            if ((!isEmpty(getters.list(type)) && !reFetch) || (state.fetching && state.promises.loadAll[type])) {
                return Promise.resolve();
            }
            if (state.promises.loadAll[type]) {
                return state.promises.loadAll[type];
            }
            commit('setFetching', { fetching: true });
            const promise = fetchStatuses(type)
                .then((resStatuses) => {
                    commit('clearList', { type });
                    const statuses = injectColorsStatus(resStatuses, type);
                    commit('updateList', { list: statuses });
                })
                .catch((error) => {
                    commit('setError', { error });
                    throw error;
                })
                .finally(() => {
                    commit('setFetching', { fetching: false });
                    commit('setPromise', { key: `loadAll.${type}`, promise: null });
                });
            commit('setPromise', { key: `loadAll.${type}`, promise });

            return promise;
        },
        updateList ({ commit }, { list, type }) {
            commit('clearList', { type });
            const statuses = injectColorsStatus(list, type);
            commit('updateList', { list: statuses });
        },
    },
    getters: {
        list: (state) => (type) => {
            if (type) {
                return state.list.filter((status) => status.type === type);
            }

            return state.list;
        },
        statusItemById: (state) => (id) => state.list.find((status) => status.id === id),
    },
};

export default statuses;
